import { useEffect, useState } from "react";

import PaymentButton from "./button";
import PaymentContent from "./content";

const Payment = ({ currentStageDetails }) => {
  const [loading, setLoading] = useState(false);
  const terminalList = currentStageDetails?.page_info?.find(
    (el) => el.component_name === "payment_methods"
  )?.infos;
  const amount = currentStageDetails?.page_info?.find(
    (el) => el.component_name === "payment_amount"
  )?.infos?.[0]?.value;

  const [paymentMethod, setPaymentMethod] = useState(terminalList?.[0]?.value);

  const onChangeMethods = (e) => {
    setPaymentMethod(e.target.value);
  };

  const onPaymentReq = async () => {
    setLoading(true);
    window.location.href = paymentMethod;
  };

  useEffect(() => {
    return () => {
      setLoading(false);
    };
  }, []);

  return (
    <div className="pt-8">
      <div className="p-5">
        <PaymentContent
          data={{ amount, payment_methods: terminalList }}
          paymentMethod={paymentMethod}
          onChangeMethods={onChangeMethods}
        />
      </div>
      <PaymentButton
        loading={loading}
        paymentMethod={paymentMethod}
        onPaymentReq={onPaymentReq}
      />
    </div>
  );
};
export default Payment;
